import { render, staticRenderFns } from "./ModalAcep.vue?vue&type=template&id=6c6ba822"
import script from "./ModalAcep.vue?vue&type=script&lang=js"
export * from "./ModalAcep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports